import { VStack, HeadingText, SupportingText, Icon, Center } from '@common/components';

const ForgotHeader = ({ email }) =>
(
    <VStack spacing="12px" textAlign="center">
        <Center bg="#F7FAFC" borderRadius="full" boxSize="56px">
            <Icon icon="email" color="#5A81A4" size="23px" />
        </Center>
        <HeadingText>Comprueba tu correo electrónico</HeadingText>
        <SupportingText>{`Hemos enviado un enlace para restablecer la contraseña a ${email}`}</SupportingText>
    </VStack>
);

export default ForgotHeader;